import { cloneElement, type ReactElement } from 'react';
import Tooltip from '@mui/material/Tooltip';
import IconButton, { type IconButtonProps } from '@mui/material/IconButton';

export interface TooltipActionItemProps extends Omit<IconButtonProps, 'title'> {
    label: string;
    icon: ReactElement;
}

/**
 * One row-action icon button with a hover tooltip (the label). The Tooltip
 * wraps the button so the actions read like the toolbar's other buttons. The
 * grid's actions cell clones this element to inject `onClick` and the roving
 * `tabIndex`, so they are spread onto the inner IconButton. A disabled button
 * is wrapped in a span so the tooltip still shows.
 */
export function TooltipActionItem({
    label,
    icon,
    disabled,
    ...other
}: TooltipActionItemProps) {
    const button = (
        <IconButton
            size="small"
            role="menuitem"
            aria-label={label}
            disabled={disabled}
            {...other}
        >
            {cloneElement(icon as ReactElement<{ fontSize?: string }>, {
                fontSize: 'small'
            })}
        </IconButton>
    );
    return (
        <Tooltip title={label}>
            {disabled ? (
                <span style={{ display: 'inline-flex' }}>{button}</span>
            ) : (
                button
            )}
        </Tooltip>
    );
}
